var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 2V22C20.5 22.2652 20.3946 22.5196 20.2071 22.7071C20.0196 22.8946 19.7652 23 19.5 23H13.5C13.2348 23 12.9804 22.8946 12.7929 22.7071C12.6054 22.5196 12.5 22.2652 12.5 22L12.5 2C12.5 1.73478 12.6054 1.48043 12.7929 1.29289C12.9804 1.10536 13.2348 1 13.5 1H19.5C19.7652 1 20.0196 1.10536 20.2071 1.29289C20.3946 1.48043 20.5 1.73478 20.5 2ZM14.5 3V21H18.5V3H14.5ZM9.5 1C9.23478 1 8.98043 1.10536 8.79289 1.29289C8.60536 1.48043 8.5 1.73478 8.5 2L8.5 22C8.5 22.2652 8.60536 22.5196 8.79289 22.7071C8.98043 22.8946 9.23478 23 9.5 23C9.76522 23 10.0196 22.8946 10.2071 22.7071C10.3946 22.5196 10.5 22.2652 10.5 22L10.5 2C10.5 1.73478 10.3946 1.48043 10.2071 1.29289C10.0196 1.10536 9.76522 1 9.5 1ZM5.5 1C5.23478 1 4.98043 1.10536 4.79289 1.29289C4.60536 1.48043 4.5 1.73478 4.5 2V22C4.5 22.2652 4.60536 22.5196 4.79289 22.7071C4.98043 22.8946 5.23478 23 5.5 23C5.76522 23 6.01957 22.8946 6.20711 22.7071C6.39464 22.5196 6.5 22.2652 6.5 22L6.5 2C6.5 1.73478 6.39464 1.48043 6.20711 1.29289C6.01957 1.10536 5.76522 1 5.5 1Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueue);
export default __webpack_public_path__ + "static/media/queue.30c23005a7012299448cdb7b851b45dd.svg";
export { ForwardRef as ReactComponent };